import { Injectable } from '@angular/core';


@Injectable()
export class ConfigurationManager {

  private API_KEY_DEV = 'gWrmUUpguKa59qn4ePaZc8XIXvgGAdx06oQzrvrV';
  private API_KEY_PROD = 'PrEisiEV3022p14z7iNye8dnqpStaf5ya2Hv3nTT';
  // private API_KEY_SIT = 'J8tVR0Rbgx9Tt8XVzjZrK6SoqDPWMQ6Q8YY7iqWm';
  //  private API_KEY_STG = 'tUmH5nzIhynT4tS1cZzf8l1CTt8nArZ2f98CkcN2';
  private API_KEY_SIT = 'CAbBaf8BPe7cTtt5wTccm4qwyJCpJWr01FmBbtMk';
  private API_KEY_STG = 'VBiXRxYowu3BQ0YuI1Vez7r2DVglo3ju9OoSONDq';

  private zipCode = '48126';
  private proxyUI = '3003542886';
  private clubCode = '047';
  private IsAuthinticated = true;
  private Latitude = 0;
  private Longitude = 0;
  private sessionId = null;
  private customerToken = '38b0e77f-6295-40dc-a858-72a3ff2308a3';
  private environment = 'STG'; // DEV SIT PROD
  // private  consumerTokenExpiration = '2024-06-02T11:51:36.4879521';
  // private   customerToken =  '187719cd-087e-4c94-a2f5-cef9929e1ee4';

  private BASE_URL_DEV = 'https://api.dev-dnr.acg.aaa.com/';
  private BASE_URL_SIT = 'https://api.sit-dnr.acg.aaa.com/';
  private BASE_URL_STG = 'https://api.stg-dnr.acg.aaa.com/';
  private BASE_URL_PROD = 'https://api.dnr.acg.aaa.com/';

  debugMode = false;
  DEV = { apikey: this.API_KEY_DEV, baseurl: this.BASE_URL_DEV };
  SIT = { apikey: this.API_KEY_SIT, baseurl: this.BASE_URL_SIT };
  STG = { apikey: this.API_KEY_STG, baseurl: this.BASE_URL_STG };
  PROD = { apikey: this.API_KEY_PROD, baseurl: this.BASE_URL_PROD };

  get isDebugEnable() {
    return this.debugMode;
  }

  set setdebugEnable(debugMode) {
    this.debugMode = debugMode;
  }

  set setEnvironmentConfig(environment: string) {
    this.environment = environment;
  }

  get getEnvironmentName() {
    return this.environment;
  }

  get environmentConfig() {
    let env;
    switch (this.environment) {
      case 'DEV': {
        env = this.DEV;
        break;
      }
      case 'SIT': {
        env = this.SIT;
        break;
      }
      case 'STG': {
        env = this.STG;
        break;
      }
      case 'PROD': {
        env = this.PROD;
        break;
      }
      default: {
        env = this.STG;
        break;
      }
    }
    return env;

  }

  set setZipCode(zipCode: string) {
    this.zipCode = zipCode;
  }

  get getZipCode() {
    return this.zipCode;
  }
  set setCustomerToken(customerToken: string) {
    this.customerToken = customerToken;
  }

  get getCustomerToken() {
    return this.customerToken;
  }

  set setProxyUI(proxyId: string) {
    this.proxyUI = proxyId;
  }

  get getProxyUI() {
    return this.proxyUI;
  }

  set setClubCode(clubCode: string) {
    this.clubCode = clubCode;
  }

  get getClubCode() {
    return this.clubCode;
  }

  set setAuthinticated(IsAuthinticated: boolean) {
    this.IsAuthinticated = IsAuthinticated;
  }

  get getAuthinticated() {
    return this.IsAuthinticated;
  }

  set setLatitude(Latitude: number) {
    this.Latitude = Latitude;
  }

  get getLatitude() {
    return this.Latitude;
  }

  set setLongitude(Longitude: number) {
    this.Longitude = Longitude;
  }

  get getLongitude() {
    return this.Longitude;
  }

  get getSessionId() {
    if (this.sessionId == null) {
      return this.generateSessionId();
    } else {
      return this.sessionId;
    }
  }

  generateSessionId() {
    this.sessionId = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      const r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
    // this.sessionId = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
    return this.sessionId;
  }
}
